import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { alpha, Box, CircularProgress } from '@mui/material';
import { PointsIcon } from 'components/common/PointsIcon';
import { HourglassEmptyOutlined } from '@mui/icons-material';
import { getPoints } from 'services/depositService';

const Rewards: React.FC = () => {
  const [totalPoints, setTotalPoints] = useState<number>(0);
  const [pendingPoints, setPendingPoints] = useState<number>(0);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    setIsLoading(true);
    getPoints()
      .then((points) => {
        setTotalPoints(points.currentPoints);
        setPendingPoints(points.pendingPoints);
      })
      .catch((error) => {
        console.error('Error fetching points:', error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 3,
      }}
    >
      <Typography variant="h5" gutterBottom sx={{ fontWeight: 600 }}>
        My Rewards
      </Typography>

      {isLoading ? (
        <Box
          sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box
          sx={{
            width: '100%',
            maxWidth: 400,
            mt: 0,
            p: 3,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
            }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Total Points
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PointsIcon size={24} />
              <Typography variant="h6" sx={{ fontWeight: 600 }}>
                {totalPoints}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={(theme) => ({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              border: `1px solid ${theme.palette.warning.main}`,
              background: alpha(theme.palette.warning.main, 0.1),
              borderRadius: '8px',
            })}
          >
            <Box sx={{ display: 'flex' }}>
              <HourglassEmptyOutlined
                sx={(theme) => ({ color: theme.palette.warning.main, mr: 1 })}
              />
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                Pending
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PointsIcon size={24} />
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {pendingPoints}
              </Typography>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Rewards;
